import { showEmptyCartModal } from "../helper/showEmptyCartModal";

export function showHashMismatchModal(cartSize) {
    if (cartSize === 0) {
        showEmptyCartModal();
    } else {
        setTimeout(function () {
            const dialog = document.getElementById('hash_mismatch_modal');

            if (!dialog) {
                return;
            }

            dialog.showModal();

            requestAnimationFrame(function () {
                dialog.focus();
            });
        }, 100);
    }
}
